export function findValidCoordsBetweenSteps(
  boxes,
  index,
  step = 1,
  showLastTrack
) {
  if (!boxes) return null;

  const until = showLastTrack ? 0 : index - step;
  for (let i = index; i > until; i--) {
    if (boxes[i] !== undefined && boxes[i] !== null) {
      return boxes[i];
    }
  }
  return null;
}

const formatter = new Intl.NumberFormat("ru", {
  minimumFractionDigits: 0,
  minimumIntegerDigits: 2,
  maximumFractionDigits: 0,
  roundingMode: "floor",
});

export function getFormattedDuration(duration) {
  const totalSeconds = Math.floor(duration);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const h = formatter.format(hours);
  const m = formatter.format(minutes);
  const s = formatter.format(seconds);

  return `${h}:${m}:${s}`;
}
